import * as Types from '../constants/actionTypes';
const initState = {
    countriesList: [],
    programCountriesList: [],
    portalUserCountries: [],
    addedPortalUserCountry: [],
}
export default (state = initState, action) => {
    // console.log(`state in auth is :`, state);
    switch (action.type) {
        case Types.SET_ALL_COUNTRIES: {
            return {
                ...state,
                allCountries: action.allCountries
            }
        }

        case Types.COUNTRIES_DETAIL_SUCCESS:
            return {
                ...state,
                countriesList: action.payload
            }
        case Types.COUNTRIES_ADDED_SUCCESS:
            state.countriesList.push(action.payload)
            return {
                ...state,
                //countriesList: action.payload
            }
        case Types.COUNTRIES_DELETED_SUCCESS:
            const existCountryList = state.countriesList.filter((data) => data.id !== action.payload)
            return {
                ...state,
                countriesList: existCountryList,
                deletedCountryInfoStatus: action.payload
            }
        case Types.COUNTRIES_ERROR:
            return {
                ...state,
                countryError: action.countryError
            }

        case Types.ALL_COUNTRIES_LIST:
            return {
                ...state,
                allCountries: action.allCountries
            }
        case Types.ALL_PORTAL_USER_COUNTRIES_LIST:
            return {
                ...state,
                allPortalUserCountries: action.payload
            }
        case Types.COUNTRIES_UPDATE_SUCCESS:
            const updateIndex = state.countriesList.findIndex((data) => { return data.id === action.payload.id });
            if (updateIndex > -1) {
                state.countriesList[updateIndex] = action.payload
            }
            return {
                ...state
            }
        case Types.COUNTRY_INFO_COUNT_SUCCESS:
            return Object.assign({}, state, { countryInfoCount: action.payload })
        case Types.PROGRAM_COUNTRIES_LIST:
            return {
                ...state,
                programCountriesList: action.payload.data
            }
        case Types.PORTAL_USER_COUNTRIES_LIST:
            return {
                ...state,
                portalUserCountries: action.payload
            }
        case Types.PORTAL_USER_COUNTRIES_ADDED_SUCCESS:
            return {
                ...state,
                addedPortalUserCountry: action.payload
            }
        case Types.DELETED_USER_COUNTRY:
            const copyPortalUserCountries = Object.assign([], state.portalUserCountries);
            copyPortalUserCountries.splice(action.deletedUserCountryIndex, 1);
            return {
                ...state,
                portalUserCountries: copyPortalUserCountries
            }
            
        case Types.DELETED_USER_COUNTRY_ERROR:
            return {
                ...state,
                portalUserCountryError: action.countryError
            }
        case Types.UPDATE_COUNTRIES_BY_REGION:
           return {
                    ...state,
                    countriesRegionList: action.payload
                }
        case Types.DELETE_COUNTRIES_BY_REGION:
            return {
                    ...state,
                    countriesRegionList: action.payload
                    }
        case Types.HOLIDAY_UPLOAD_SUCCESS:
            return {
                ...state,
                holidayUploadError: action.payload
            }
        case Types.HOLIDAY_UPLOAD_ERROR:
            return {
                ...state,
                holidayUploadError: action.error
            }
        default:
            return state;
    }
};